import React, { useState, useReducer } from 'react';
import {
  TextField,
  Button,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import { InputAdornment } from '@mui/material'; // Import InputAdornment
import { Modal } from '@mui/material'; // Import Modal
import { FormControl } from '@mui/material'; // Import FormControl
import { FormHelperText } from '@mui/material';

const initialNewState = {
    name: '',
    price: '',
    type: '',
    tags: ''
}

const reducer = (state, action) => {
    switch (action.type) {
        case 'name':
            return { ...state, name: action.value }
        case 'price':
            return { ...state, price: action.value }
        case 'type':
            return { ...state, type: action.value }
        case 'tags':
            return { ...state, tags: action.value }
    }
    return state
}

const NewItemModal = ({ isModalOpen, closeModal, doAddItem }) => {
    const [state, dispatch] = useReducer(reducer, initialNewState)
    const [nameError, setNameError] = useState('');
    const [priceError, setPriceError] = useState('');
    const [tagError, setTagError] = useState('');
    const [typeError, setTypeError] = useState('');

    const resetErrors = () => {
        setNameError('');
        setPriceError('');
        setTagError('');
        setTypeError('');
    }

    const handleClose = () => {
        closeModal()
        resetErrors()
    }

    const handleInputChange = (type, value) => {
        dispatch({ type, value: value })
    }

    const handleAddItem = () => {
        let hasErrors = false;
    
        // Reset errors
        resetErrors()

        // Basic validation
        if (!state?.name?.trim()) {
            setNameError('Name is required');
            hasErrors = true;
        }
        if (!state?.price?.trim()) {
            setPriceError('Price is required');
            hasErrors = true;
        } else if (isNaN(Number(state?.price)) || Number(state?.price) < 0) {
            setPriceError('Price must be a non-negative number');
            hasErrors = true;
        }
        if (!state?.tags?.trim()) {
            setTagError('Tags are required');
            hasErrors = true;
        }
        if (!state?.type?.trim()) {
            setTypeError('Type is rquired');
            hasErrors = true;
        }
        if (hasErrors) {
            return; // Stop if there are errors
        }

        doAddItem(state?.name, state?.price, state?.tags, state?.type)
    }

    // Modal Styles
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'white',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        borderRadius: 8,
    };

    return (
        <Modal open={isModalOpen} onClose={handleClose} aria-labelledby="add-item-modal-title">
            <Box sx={modalStyle}>
                <Typography id="add-item-modal-title" variant="h6" component="h2" mb={4}>
                    Add New Item
                </Typography>

                <div>Name: </div>
                <FormControl fullWidth error={!!nameError} margin="normal">
                <TextField
                    id="name"
                    name="name"
                    value={state.name}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                    aria-describedby="name-error-text"
                />
                <FormHelperText id="name-error-text">{nameError}</FormHelperText>
                </FormControl>
                
                <div>Price:</div>
                <FormControl fullWidth error={!!priceError} margin="normal">
                <TextField
                    id="price"
                    name="price"
                    type="number"
                    value={state.price}
                    onChange={(e) => handleInputChange('price', e.target.value)}
                    InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    }}
                    aria-describedby="price-error-text"
                />
                <FormHelperText id="price-error-text">{priceError}</FormHelperText>
                </FormControl>

                <div>Restaurant Type (fast casual, etc...): </div>
                <FormControl fullWidth error={!!typeError} margin="normal">
                <TextField
                    id="type"
                    name="type"
                    value={state.type}
                    onChange={(e) => handleInputChange('type', e.target.value)}
                    aria-describedby="type-error-text"
                />
                <FormHelperText id="type-error-text">{typeError}</FormHelperText>
                </FormControl>

                <div>Tags (comma separated): </div>
                <FormControl fullWidth error={!!tagError} margin="normal">
                <TextField
                    id="tags"
                    name="tags"
                    value={state.tags}
                    onChange={(e) => handleInputChange('tags', e.target.value)}
                    aria-describedby="tag-error-text"
                />
                <FormHelperText id="tag-error-text">{tagError}</FormHelperText>
                </FormControl>

                <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
                <Button onClick={closeModal}>Cancel</Button>
                <Button variant="contained" onClick={handleAddItem}>
                    Add
                </Button>
                </Box>
            </Box>
        </Modal>
    )
}

export default NewItemModal